import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  SiWindows,
  SiVisualstudiocode,
  SiIntellijidea,
  SiAndroidstudio,
  SiGithub,
  SiPostman,
  SiVercel,
  SiFirebase,
  SiAmazonaws,
  SiGooglechrome,
} from "react-icons/si";

const tools = [
  { icon: <SiWindows />, name: "Windows" },
  { icon: <SiVisualstudiocode />, name: "VS Code" },
  { icon: <SiIntellijidea />, name: "IntelliJ IDEA" },
  { icon: <SiAndroidstudio />, name: "Android Studio" },

  { icon: <SiPostman />, name: "Postman" },
  { icon: <SiAmazonaws />, name: "AWS Console" },
];

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map(({ icon, name }, idx) => (
        <Col xs={4} md={2} className="tech-icons" key={idx}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${name}`}>{name}</Tooltip>}
          >
            <span>{icon}</span>
          </OverlayTrigger>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
